import { Routes, Route } from 'react-router-dom'
import ScrollToTop from './components/ScrollToTop'
import HomePage from './pages/HomePage'
import ItemsPage from './pages/ItemsPage'
import CheckoutPage from './pages/CheckoutPage'
import OrderConfirmationPage from './pages/OrderConfirmationPage'
import MyOrdersPage from './pages/MyOrdersPage'
import LoginPage from './pages/LoginPage'
import AdminLoginPage from './pages/AdminLoginPage'
import AdminLayout from './layouts/AdminLayout'
import DashboardPage from './pages/admin/DashboardPage'
import ProductsPage from './pages/admin/ProductsPage'
import AnalyticsPage from './pages/admin/AnalyticsPage'

export default function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
      {/* One layout route so moving between the item lists and the forms keeps HomePage (and its inventory) mounted. */}
      <Route element={<HomePage />}>
        <Route path="/" element={null} />
        <Route path="/feedback" element={null} />
        <Route path="/request-item" element={null} />
      </Route>
      <Route path="/items" element={<ItemsPage />} />
      <Route path="/checkout" element={<CheckoutPage />} />
      <Route path="/orders" element={<MyOrdersPage />} />
      <Route path="/order/:orderNumber" element={<OrderConfirmationPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/admin/login" element={<AdminLoginPage />} />
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<DashboardPage />} />
        <Route path="products" element={<ProductsPage />} />
        <Route path="analytics" element={<AnalyticsPage />} />
      </Route>
    </Routes>
    </>
  )
}
